<template>
  <transition name="fade">
    <div class="userModal" v-if="show">
      <div class="overlay" v-on:click="close(false)"></div>
      <div :class="{modalContent: true, modalBig: true}">
        <div class="close" v-on:click="close(false)"></div>
        <div :class="{thePlyr: true, vert: vert,
          hasThumb: showThumb}">
          <VuePlyr ref="video" v-if="showVideo">
            <video></video></VuePlyr>
        </div>
        <div class="loadingVideo" v-if="!showVideo"></div>
        <div class="thumbs" v-if="showThumb">
          <div class="thumb a1" v-on:click="play1a"></div>
          <div class="thumb a2" v-on:click="play2a"></div>
          <div class="thumb a3" v-on:click="play3a"></div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import VuePlyr from 'vue-plyr';
import 'vue-plyr/dist/vue-plyr.css';

export default {
  components: { VuePlyr },
  data() {
    return {
      show: false,
      vert: false,
      showThumb: false,
      showVideo: true,
    };
  },
  computed: {
  },
  methods: {
    open(d, n) {
      this.show = true;
      this.vert = d.title === 'beauty';
      this.showThumb = d.thumb === true;
      this.showVideo = true;
      setTimeout(() => {
        this.$refs.video.player.source = {
          type: 'video',
          title: d.title,
          sources: d.sources,
        };
        this.$refs.video.player.play();
      });
    },
    play1a() {
      this.$refs.video.player.destroy();
      this.showVideo = false;
      setTimeout(() => {
        this.showVideo = true;
        setTimeout(() => {
          this.$refs.video.player.sources = {
            type: 'video',
            title: 'mixed-collagen',
            sources: [
              {
                src: 'https://storage.googleapis.com/deepdivedjkt/clg/mixed-collagen-1080.mp4',
                type: 'video/mp4',
                size: 1080,
              },
              {
                src: 'https://storage.googleapis.com/deepdivedjkt/clg/mixed-collagen-720.mp4',
                type: 'video/mp4',
                size: 720,
              },
              {
                src: 'https://storage.googleapis.com/deepdivedjkt/clg/mixed-collagen-480.mp4',
                type: 'video/mp4',
                size: 480,
              },
              {
                src: 'https://storage.googleapis.com/deepdivedjkt/clg/mixed-collagen-360.mp4',
                type: 'video/mp4',
                size: 360,
              },
            ],
          };
          this.$refs.video.player.play();
        }, 600);
      }, 600);
    },
    play2a() {
      this.$refs.video.player.destroy();
      this.showVideo = false;
      setTimeout(() => {
        this.showVideo = true;
        setTimeout(() => {
          this.$refs.video.player.source = {
            type: 'video',
            title: 'mixed-collagen-drink',
            sources: [
              {
                src: 'https://storage.googleapis.com/deepdivedjkt/clg/mixed-collagen-drink-1080.mp4',
                type: 'video/mp4',
                size: 1080,
              },
              {
                src: 'https://storage.googleapis.com/deepdivedjkt/clg/mixed-collagen-drink-720.mp4',
                type: 'video/mp4',
                size: 720,
              },
              {
                src: 'https://storage.googleapis.com/deepdivedjkt/clg/mixed-collagen-drink-480.mp4',
                type: 'video/mp4',
                size: 480,
              },
              {
                src: 'https://storage.googleapis.com/deepdivedjkt/clg/mixed-collagen-drink-360.mp4',
                type: 'video/mp4',
                size: 360,
              },
            ],
          };
          this.$refs.video.player.play();
        }, 600);
      }, 600);
    },
    play3a() {
      this.$refs.video.player.destroy();
      this.showVideo = false;
      setTimeout(() => {
        this.showVideo = true;
        setTimeout(() => {
          this.$refs.video.player.sources = {
            type: 'video',
            title: 'orangeberry-collagen',
            sources: [
              {
                src: 'https://storage.googleapis.com/deepdivedjkt/clg/orangeberry-collagen-1080.mp4',
                type: 'video/mp4',
                size: 1080,
              },
              {
                src: 'https://storage.googleapis.com/deepdivedjkt/clg/orangeberry-collagen-720.mp4',
                type: 'video/mp4',
                size: 720,
              },
              {
                src: 'https://storage.googleapis.com/deepdivedjkt/clg/orangeberry-collagen-480.mp4',
                type: 'video/mp4',
                size: 480,
              },
              {
                src: 'https://storage.googleapis.com/deepdivedjkt/clg/orangeberry-collagen-360.mp4',
                type: 'video/mp4',
                size: 360,
              },
            ],
          };
          this.$refs.video.player.play();
        }, 600);
      }, 600);
    },
    close(b, d) {
      this.show = false;
    },
  },
};
</script>

<style lang="scss">
  .thePlyr.vert{
    .plyr video{
      height: 540px !important;
      width: auto !important;
      margin: 0 auto !important;
      @media (max-width: 680px) {
        height: 240px !important;
      }
    }
    .plyr__video-wrapper{
      text-align: center;
    }
    &.hasThumb{
      .plyr video{
        @media (max-height: 700px) {
          height: 480px !important;
        }
      }
    }
  }
</style>
<style scoped lang="scss">
.loadingVideo{
  height: 400px;
  background-size: 46px auto;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url(../assets/loading.svg);
  background-color: #ffc9ca;
}
  .userModal{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9991;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: auto;
    padding: 40px 0;
    @media (max-width: 680px) {
      padding: 20px 10px;
    }
    .overlay{
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0,0,0,.7);
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
    }
    .modalContent{
      position: relative;
      z-index: 2;
      width: 860px;
      margin: auto;
      border-radius: 5px;
      transition: all .3s ease;
      background-color: #ffe7ea;
      @media (min-width: 681px) {
        min-height: 400px;
      }
      iframe{
        border: none;
      }
      .thumbs{
        display: flex;
        justify-content: center;
        margin: 16px 0;
        .thumb{
          width: 80px; height: 80px;
          background-color: #000;
          margin: 0 8px;
          border-radius: 10px;
          background-position: center;
          background-size: cover;
          position: relative;
          cursor: pointer;
          &:before{
            content: "";
            width: 40px; height: 40px;
            background-image: url(../assets/play.png);
            background-size: 30px auto;
            background-position: center;
            background-repeat: no-repeat;
            position: absolute;
            transition: all .3s ease;
            top: 50%; left: 50%;
            margin: -20px 0 0 -20px;
          }
          &.a1{
            background-image: url(../assets/1a.jpg);
          }
          &.a2{
            background-image: url(../assets/2a.jpg);
          }
          &.a3{
            background-image: url(../assets/3a.jpg);
          }
        }
      }
      .close{
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background-image: url(../assets/close.png);
        background-size: 14px auto;
        background-position: center;
        background-repeat: no-repeat;
        position: absolute;
        right: -10px;
        top: -10px;
        background-color: #fcdf51;
        cursor: pointer;
        transition: all .2s linear;
        z-index: 991;
      }
      .close:hover{
        background-color: #fcdf51;
      }
    }
  }
</style>
